import { render, staticRenderFns } from "./firstAppointment.vue?vue&type=template&id=4c1a0869&scoped=true&"
import script from "./firstAppointment.vue?vue&type=script&lang=js&"
export * from "./firstAppointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1a0869",
  null
  
)

export default component.exports